import { Action, createReducer, on } from '@ngrx/store';
import * as NotificationActions from './notifications.actions';
import { Notification } from '../notification.model';

export interface NotificationState {
  notifications: Notification[];
  error: boolean;
  loading: boolean;
}

export const notificationInitialState: NotificationState = {
    notifications: [],
    error: false,
    loading: false,
  }
;

const reducer = createReducer(
  notificationInitialState,
  on( NotificationActions.loadNotifications, (state) => ({
    ...state,
    loading: true,
  }) ),
  on( NotificationActions.loadNotificationsSuccess, (state, { notifications }) => ({
    ...state,
    notifications,
    load: false,
  }) ),
  on( NotificationActions.notificationReceived, (state, { notification }) => ({
    ...state,
    notifications: [ notification, ...state.notifications ],
    load: false,
  }) ),
  on( NotificationActions.loadNotificationsFailure, (state) => ({
    ...state,
    load: false,
    error: true,
  }) ),
);

export function NotificationsReducer(state: NotificationState | undefined, action: Action){
  return reducer( state, action );
}
